module.exports = __webpack_public_path__ + "static/media/fs2-v2.81fea5df.png";